import { T }             from 'defa-object';
import ControlModule     from 'scripts/poppet/control-module';
import { DateConverter } from 'scripts/utils/date-converter';
import template          from 'templates/controlDayAndNight.jst.html';
import { Vue }           from 'vue/defavue';
import vueTemplate       from './view-control-day-and-night-view.vue.html';

const selectors = {
	region       : '[data-region=day-and-night-container]',
	closeButton  : '[data-click=dayAndNight-close]'
};

const actionOptions     = [
	{ value: 'ON', 	title: T.tc('DayAndNight','Enabled'), titleContext: 'DayAndNightTimes' },
	{ value: 'OFF', title: T.tc('DayAndNight','Disabled'),	titleContext: 'DayAndNightTimes' }
];

let radioStrip =  null;
let dayAndNightComponent = null;

export const ControlDayAndNightView = ControlModule.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template : template,

	ui: {
		close : selectors.closeButton,
		region: selectors.region,
	},
	
	events: {
		'click @ui.close'  : 'onClickClose'
	},
	

	
	className: function () {
		return this._getClassName( 'control-day-and-night' );
	},
	
	
	onClickClose: function(){
		this.trigger('close', this)
	},
	
	/**
	 * Triggers when the html is rendered in the DOM.
	 * @void
	 */
	onDomRefresh() {
		let self   = this;
		
		radioStrip = new Vue ({
			el: '#enable-strip',
			bb() {
				return {
					model: self.model,
				}
			},
			data() {
				return {
					nightModeEnabledValue: 'ON',
					actionOptions,
				}
			},
			methods: {
				save(newValue, attributeName) {
					let data = {};
					if ('OFF' === this.nightModeEnabledValue) {
						dayAndNightComponent.editingObject = null;
					}
					data[attributeName]= 'ON' === newValue;
					self.save(data);
				}
			},
			
			watch: {
				'model.nightModeEnabled': function (newAttribute){
					this.nightModeEnabledValue = newAttribute ? 'ON' : 'OFF';
				}
			},
			
			created() {
				this.nightModeEnabledValue = this.model.nightModeEnabled ? 'ON' : 'OFF';
			}
		});
		
		let region = this.ui.region[ 0 ];
		
		dayAndNightComponent = new Vue( {
			template: vueTemplate,
			bb() {
				return {
					model: self.model
				};
			},
			data() {
				return {
					isEditingDay : null,
					editingObject: null,
					showInfoEnableMode: false,
					showInfoStartTime: false,
				};
			},
			computed: {
				canSave() {
					let time = this.isEditingDay ? this.model.get('dayStartTime') :this.model.get('nightStartTime');
					return this.editingObject !== null && this.editingObject.time !== time;
				},
				dayStartTimeDisplayValue() {
					if(this.model.dayStartTime && this.model.dayStartTime.length > 5 ){
						return DateConverter.fromUTCTimeToLocalTime(this.model.dayStartTime)
					}
					return this.model.dayStartTime
				},
				
				nightStartTimeDisplayValue() {
					if(this.model.nightStartTime && this.model.nightStartTime.length > 5 ){
						return DateConverter.fromUTCTimeToLocalTime(this.model.dayStartTime)
					}
					return this.model.nightStartTime
				}
			},
			methods : {
				cancelEditing() {
					this.editingObject = null;
					this.isEditingDay  = null;
				},
				
				saveRow() {
					let data = {};
					if ( this.isEditingDay ) {
						data.dayStartTime = DateConverter.fromLocalTimeToUTCTime(this.editingObject.time);
					} else {
						data.nightStartTime = DateConverter.fromLocalTimeToUTCTime(this.editingObject.time);
					}
					this.cancelEditing();
					this.$emit( 'save', data );
				},
				
				editDay( ) {
					this.isEditingDay  = true;
					this.editingObject = {time: this.model.get('dayStartTime'), title: T.tc('DayAndNight', 'Day starts at...')};
				},
				editNight() {
					this.isEditingDay  = false;
					this.editingObject = { time: this.model.get( 'nightStartTime' ), title: T.tc('DayAndNight','Night starts at...')};
				},
				infoEnableModeClicked() {
					this.showInfoEnableMode = !this.showInfoEnableMode;
				},
				infoStartTimeClicked() {
					this.showInfoStartTime = !this.showInfoStartTime;
				},
			}
		} );
		dayAndNightComponent.$mount( region );
		dayAndNightComponent.$on( 'save', ( data ) => {
			this.save(data);
		} );
	},
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------

	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	save: function(attributes) {
		this.model.set('isValidData', false);
		try {
			this.model.save(attributes, {
				isSaving: true,
				patch: true,
				success: function () {
					console.log( Object.keys(attributes)[0] +' was succesfully saved!' );
				},
				error  : function (model, response) {
					console.error( Object.keys(attributes)[0] + ' failed saving with error: ' + response.responseJSON.message );
				}
			});
		} catch ( err ) {
			console.error( err );
			setTimeout( () => this.idle(), 1000 );
		}
	}
	
});

export default  ControlDayAndNightView;
